import { render, staticRenderFns } from "./NbBorderTextInput.vue?vue&type=template&id=2da81b28&scoped=true&"
import script from "./NbBorderTextInput.vue?vue&type=script&lang=js&"
export * from "./NbBorderTextInput.vue?vue&type=script&lang=js&"
import style0 from "./NbBorderTextInput.vue?vue&type=style&index=0&id=2da81b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da81b28",
  null
  
)

export default component.exports